export const appConfig = {
  API_URL: process.env.REACT_APP_SERVER_URL,
  ENVIRONMENT: process.env.NODE_ENV
};
